
import statisticalAnalysis from './index.vue';
var Plugin = {
    install: function install(Vue) {
        Vue.component('statistical-analysis', statisticalAnalysis);
    }
};
export { statisticalAnalysis };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/statistical-analysis/index.js
// module id = 1
// module chunks = 0